<template>
  <div>
    <!-- <main-layout>
      <div>
        <v-container> -->
    <div>
      <v-tabs
        v-if="$store.state.privilege.role !== 'agency'"
        v-model="currentView"
        color="white"
        :slider-color="$vuetify.theme.primary"
        style="font-size: 18px;margin-bottom: 30px;"
      >
        <template>
          <v-tab
            style="text-transform: capitalize"
            ripple
            :key="'project-info'"
            :href="'#project-info'"
            >{{ $t('Project info') }}</v-tab
          >
          <v-tab
            style="text-transform: capitalize"
            ripple
            :key="'project-type'"
            :href="'#project-type'"
            >{{ $t('Project type') }}</v-tab
          >

          <v-tab
            style="text-transform: capitalize"
            ripple
            :key="'project-form'"
            :href="'#project-form'"
            >{{ $t('Project form') }}</v-tab
          >
          <v-tab
            style="text-transform: capitalize"
            ripple
            :key="'project-customer'"
            :href="'#project-customer'"
            >{{ $t('Tag customer') }}</v-tab
          >
          <v-tab
            style="text-transform: capitalize"
            ripple
            :key="'project-symbol'"
            :href="'#project-symbol'"
            >{{ $t('Project symbol') }}</v-tab
          >
        </template>
      </v-tabs>
      <div v-if="currentView == 'project-info'">
        <ProjectInfo></ProjectInfo>
      </div>
      <div v-if="currentView == 'project-type'">
        <ProjectType></ProjectType>
      </div>
      <div v-if="currentView == 'project-step'">
        <ProjectStep></ProjectStep>
      </div>
      <div v-if="currentView == 'project-form'">
        <ProjectForm></ProjectForm>
      </div>
      <div v-if="currentView == 'project-customer'">
        <ProjectCustomer></ProjectCustomer>
      </div>
      <div v-if="currentView == 'project-symbol'">
        <ProjectSymbol></ProjectSymbol>
      </div>
      <!-- <div v-if="currentView == 'project-member'">
            <ProjectMember></ProjectMember>
          </div> -->
      <!-- <div v-if="currentView == 'project-member-count'">
              <ProjectMemberCount></ProjectMemberCount>
            </div> -->
    </div>
    <!-- </v-container>
      </div>
    </main-layout> -->
  </div>
</template>

<script>
import ProjectInfo from './ProjectInfo.vue'
import ProjectType from './ProjectType.vue'
import ProjectStep from './ProjectStep.vue'
import ProjectForm from './ProjectForm.vue'
import ProjectSymbol from './ProjectSymbol.vue'
import ProjectCustomer from './ProjectCustomer'
// import ProjectMember from './ProjectMember.vue'
// import ProjectMemberCount from './ProjectMemberCount.vue'
export default {
  components: {
    ProjectInfo,
    ProjectType,
    ProjectStep,
    ProjectForm,
    ProjectSymbol,
    ProjectCustomer
    // ProjectMember,
    // ProjectMemberCount,
  },
  data() {
    return {
      currentView: 'project-info',
      routeName: this.$route.name,
    }
  },
  created() {
    var vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      if (this.$store.state.privilege.role === 'agency') {
        vm.currentView = 'project-info'
      } else {
        vm.currentView = 'project-info'
      }
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'projectMaster',
        path: '/projectMaster',
        query: {
          tab: this.currentView,
        },
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/projectMaster/main.vue